import Slider from '@material-ui/lab/Slider';
import React, { useCallback, useRef, useState } from 'react';
import AvatarEditor from 'react-avatar-editor';
import { PX } from '../../contrib/ui';
import Button from '../Button';
import Modal from '../Modal';

interface IProps {
  updateImage: (image: string) => void;
  addPic: (pic: string) => void;
  open: boolean;
  onClose: any;
  title: string;
  base64: string;
}

export const EditImageModal = ({ open, onClose, title, base64, addPic, updateImage }: IProps) => {
  const editorRef: any = useRef(null);
  const [zoom, setZoom] = useState(1);

  const handleZoom = useCallback(
    (_: any, zoomValue: number) => {
      setZoom(zoomValue);
    },
    [zoom]
  );

  const saveImage = () => {
    if (editorRef) {
      const image = editorRef.current.getImageScaledToCanvas().toDataURL();
      updateImage(image);
      addPic(image);
      setZoom(1);
      onClose();
    }
  };

  return (
    <Modal className="modal-edit-picture" open={open} onClose={onClose} title={title}>
      <div className="edit-picture-wrapper">
        <div className="picture-editor">
          <div className="filter" style={{ backgroundImage: base64 }}>
            <div className="mask" />
          </div>
          <AvatarEditor
            ref={editorRef}
            image={base64}
            width={500 * PX}
            height={200 * PX}
            border={0}
            color={[55, 55, 55, 0.7]} // RGBA
            scale={zoom}
            rotate={0}
            borderRadius={0}
          />
        </div>

        <div className="zoom-title">ZOOM</div>
        <div className="slider-wrapper">
          <Slider
            classes={{
              track: 'zoom-slider-track',
              trackAfter: 'zoom-slider-track-after',
              trackBefore: 'zoom-slider-track-before'
            }}
            value={zoom}
            className="zoom-slider"
            aria-labelledby="label"
            onChange={handleZoom}
            min={1}
            max={3}
          />
          <div className="radius-left">
            <div className="hack" />
          </div>
          <div className="radius-right">
            <div className="hack" />
          </div>
        </div>

        <Button
          id="next"
          onClick={saveImage}
          variant="contained"
          color="primary"
          fullWidth={true}
          className="button button-shadow "
        >
          SAVE EDITS
        </Button>
      </div>
    </Modal>
  );
};
